import { createFileRoute } from '@tanstack/react-router'
import MealsDashboard from '@/features/meals/meals-dashboard'

export const Route = createFileRoute('/_authenticated/dashboard/meals/')({
  component: MealsDashboard,
})
